export default __webpack_public_path__ + "static/IMG_9296-f6297ba012be5d07792a20e1f67547a5.jpg";